import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTreeState } from 'react-stately';
import { useMenu } from 'react-aria';

import MenuSection from '../MenuSection/MenuSection';
import MenuItem from '../MenuItem/MenuItem';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './MenuList.module.scss';

const MenuList = (props) => {
    const state = useTreeState(props);

    const ref = useRef();
    const { menuProps } = useMenu(props, state, ref);

    const { setOpen } = props;

    return (
        <ul
            {...menuProps}
            ref={ref}
            className={styles.container}
        >
            {[...state.collection].map((item) => (
                item.type === 'section'
                    ? <MenuSection key={item.key} section={item} state={state} />
                    : <MenuItem key={item.key} item={item} state={state} setOpen={setOpen} />
            ))}
        </ul>
    );
};

MenuList.propTypes = {
    ...defaultAriaProps,
    setOpen: PropTypes.func
};

export default MenuList;
